// Angular
import { Injectable } from "@angular/core";
// Services
import { ApiService } from "./../api";
import { ElasticService } from "./../elastic";
import { OAuthService } from "./../o-auth";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs";
import {
  CanDeactivate,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate) {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}

@Injectable()
export class AuthGuardService {
  constructor(
    private apiService: ApiService,
    private elasticService: ElasticService,
    private oAuthService: OAuthService,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase
  ) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      const fireAuthSubscription = this.fireAuth.authState.subscribe((user) => {
        fireAuthSubscription.unsubscribe();

        if (!user) {
          this.oAuthService.logout();
          return resolve(false);
        }

        if (!this.oAuthService.getClub()) {
          this.fireDatabase
            .list(`/user-profiles/${user.uid}`)
            .subscribe((club) => {
              if (club.length > 0) {
                this.fireDatabase
                  .object("users/" + club[0].$key)
                  .subscribe((res) => {
                    return resolve(true);
                  });
              } else {
                return resolve(false);
              }
            });
        } else {
          return resolve(true);
        }
      });
    });
  }
}

@Injectable()
export class RouteAuthGuardService implements CanActivate {
  constructor(
    private apiService: ApiService,
    private elasticService: ElasticService,
    private oAuthService: OAuthService,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Promise<boolean> | Observable<boolean> {
    let appPermission = route.data["appPermission"];
    
    let operation = route.data["operation"];

    return new Promise((resolve) => {
      if (
        this.oAuthService.getClub().type == 3 &&
        this.oAuthService.getClub().role == 1
      ) {
        resolve(true);
      } else {
        this.fireDatabase
          .object(
            "user-permissions/" +
              this.oAuthService.getClub().uid +
              "/" +
              this.oAuthService.getClub().cid +
              "/" +
              appPermission
          )
          .subscribe((res) => {
            if (res.$exists()) {
              if (res[operation]) {
                resolve(true);
              } else resolve(false);
            } else {
              this.fireDatabase
                .object(
                  "master-permissions/" +
                    this.oAuthService.getClub().type +
                    "/" +
                    appPermission
                )
                .subscribe((ress) => {
                  if (ress.$exists()) {
                    if (ress[operation]) {
                      resolve(true);
                    } else resolve(false);
                  } else {
                    resolve(false);
                  }
                });
            }
          });
      }
    });
  }
}


@Injectable()
export class AdminRouteAuthGuardService implements CanActivate {
  constructor(
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
  ): boolean | Promise<boolean> | Observable<boolean> {
    let appPermission = route.data["appPermission"];
    let operation = route.data["operation"];
    return new Promise((resolve) => {
      if (
        this.oAuthService.getClub().type == 3 &&
        this.oAuthService.getClub().role == 1 
      ) {
        resolve(true);
      } else if ((this.oAuthService.getClub().type == 1 || this.oAuthService.getClub().type == 5 || this.oAuthService.getClub().type == 7) && (appPermission == "dashboard-orders" || appPermission == "events") && operation == "read") {
        resolve(true);
      }
      else if (this.oAuthService.getClub().type == 3)
      {
        this.fireDatabase
          .object(
            "user-permissions/" +
              this.oAuthService.getClub().uid +
              "/" +
              this.oAuthService.getClub().cid +
              "/" +
              "magazine_portal"
          )
          .subscribe((res) => {
            if (res.$exists()) {
              if (res["read"]) {
                resolve(false);
              } else resolve(true);
            }
            });
        }
      else resolve(false);
    });
  }
}
